import { ptBr, en, es } from './locale';

export const ConfiguracaoParamentros = {
    init: i18n => {
        i18n.mergeLocaleMessage('pt-BR', {
            configuracaoParametros: {
                ...ptBr
            }
        });
        i18n.mergeLocaleMessage('en', {
            configuracaoParametros: {
                ...en
            }
        });
        i18n.mergeLocaleMessage('es', {
            configuracaoParametros: {
                ...es
            }
        });
    }
};

export default ConfiguracaoParamentros;
